<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <nb-card class="form">
    <nb-card-header
      ><h4>
        {{ "dialogs.chatStyle.title" | translate }}
      </h4></nb-card-header
    >
    <nb-card-body>
      <div class="form-group row">
        <label for="widget_instance" class="label col-sm-3 col-form-label">
          {{ "input.name.label" | translate }}
        </label>
        <div class="col-sm-9">
          <input
            type="text"
            nbInput
            fullWidth
            id="widget_instance"
            formControlName="widget_instance"
            placeholder="{{ 'dialogs.chatStyle.namePlaceholder' | translate }}"
            [status]="showInputError('widget_instance') ? 'danger' : 'basic'"
          />
        </div>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button
        type="button"
        nbButton
        status="danger"
        outline
        (click)="dialogRef.close()"
      >
        {{ "buttons.cancel" | translate }}
      </button>
      <button type="submit" nbButton status="primary">
        {{ "buttons.save" | translate }}
      </button>
    </nb-card-footer>
  </nb-card>
</form>
